<template>
  <div
    class="my-1-5 flex w-full justify-between rounded-sm border border-gray-300 p-2-5 sm:my-2-5 sm:p-5"
  >
    <div class="flex w-8/9 justify-start">
      <div class="flex place-self-center rounded-full bg-green-100 p-2">
        <icon-base icon="checked-small" />
      </div>
      <div class="flex w-8/9 flex-col pl-2-5 text-left sm:pl-5">
        <span
          class="text-tiny-xs truncate font-medium text-gray-700 sm:text-base"
        >
          {{ file.name }}
        </span>
        <span class="text-xxs text-gray-500 sm:text-xs">
          Uploading complete
        </span>
      </div>
    </div>
    <div
      class="cursor-pointer justify-end place-self-center"
      @click="removeFileAction()"
    >
      <icon-base icon="delete" class="text-disabled-medium" />
    </div>
  </div>
</template>

<script>
import useServicingStore from "@/stores/servicing";

export default {
  name: "uploaded-file-preview",
  props: {
    offerStipId: {
      type: Number,
      requried: true,
    },
    file: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { removeFile } = useServicingStore();

    function removeFileAction() {
      removeFile({
        index: props.index,
        section: props.offerStipId,
        fileId: props.file.id,
      });
    }
    return { removeFileAction };
  },
};
</script>
